<template>
    <div class="app-widget__final">
        <h1>{{userData.patientName}}, информация о вашей онлайн-консультации</h1>
        <div class="app-widget__list-wrap">
            <ul class="app-widget__list">
                <li class="app-widget__list-item">
                    Дата / Время
                </li>
                <!--
                <li class="app-widget__list-item">
                    Телефон клиники
                </li>
                -->
                <li class="app-widget__list-item">
                    ФИО врача
                </li>
                <!--<li class="app-widget__list-item">
                    Специальность врача
                </li>-->
            </ul>
            <ul class="app-widget__list">
                <li class="app-widget__list-item">
                    <strong v-if="selectedData.timeslot">{{formatDate()}}</strong>
                </li>
                <!--
                <li class="app-widget__list-item">
                    <strong>8-800-163-59-29</strong>
                </li>
                -->
                <li class="app-widget__list-item">
                    <strong v-if="selectedData.doctors">{{selectedData.doctors.name}}</strong>
                </li>
                <li class="app-widget__list-item" v-if="false">
                    <strong v-if="selectedData.doctors">
                        <span v-for="(item, index) in selectedData.doctors.positions" :key="item.name">{{ index === 0 ? item.name : ', ' + item.name.replace('Врач','')}}</span>
                    </strong>
                </li>
            </ul>
        </div>
        <div v-if="false">
            <p class="app-widget__final-text">Для завершения вашей записи требуется онлайн оплата. Ссылку на оплату мы отправим вам в смс и по электронной почте. Также Вы можете оплатить онлайн:</p>
            <a v-bind:href="`${url}/${appointmentId}`" class="button app-widget__final-btn">Оплатить {{dateAndPricing.price}} руб</a>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'step-three',
    props: [
        'userData',
        'selectedData',
        'appointmentId',
        'dateAndPricing'
    ],
    data() {
      return {
        url: window.TELEMEDICINE_PAY_FORM_URL
      }
    },
    methods: {
      formatDate() {
        if (this.selectedData.timeslot) {
          const date = moment(this.selectedData.timeslot.time).format('DD.MM.YYYY');
          const time = moment(this.selectedData.timeslot.time).format('HH:mm');
          return `${date} в ${time}`;
        }
      }
    },
    created: function () {
      this.formatDate();
    }
}
</script>

<style lang="sass">
.app-widget
    &__final
        padding: 54px 0 0

        h1
            font-weight: bold
            font-size: 18px
            line-height: 24px
            margin: 0 0 30px
        &-text
            font-size: 14px
            line-height: 160%
            color: #222
            margin: 0 0 30px
            max-width: 556px

        &-btn
            max-width: 290px
            width: 100%

    &__list-wrap
        display: flex
        margin: 0 0 64px

    &__list
        padding: 0
        margin: 0
        list-style: none

        &:first-child
            margin: 0 52px 0 0

        &-item
            font-size: 14px
            line-height: 160%
            color: #222
            &:not(:last-child)
                margin: 0 0 10px

</style>
